module.exports = __webpack_public_path__ + "static/media/haminaProduct.1a65ddca.jpeg";